"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectEden = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
const DiscardCards_1 = require("../../deferredActions/DiscardCards");
const PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
const PlaceCityTile_1 = require("../../deferredActions/PlaceCityTile");
const PlaceGreeneryTile_1 = require("../../deferredActions/PlaceGreeneryTile");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Card_1 = require("../Card");
const Units_1 = require("../../Units");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const SelectOption_1 = require("../../inputs/SelectOption");
const OrOptions_1 = require("../../inputs/OrOptions");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class ProjectEden extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.PROJECT_EDEN,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.PLANT],
            tr: { oceans: 1, oxygen: 1 },
            metadata: {
                cardNumber: 'P58',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.oceans(1).city().greenery().br;
                    b.minus().cards(3);
                }),
                description: 'Place 1 ocean tile, 1 city tile and 1 greenery tile. Discard 3 cards.',
            },
        });
        this.selected = [];
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        const board = player.game.board;
        const canPlaceCity = board.getAvailableSpacesForCity(player).length > 0;
        const canPlaceGreenery = board.getAvailableSpacesForGreenery(player).length > 0;
        const canPlaceBothLandTiles = board.getAvailableSpacesOnLand(player).length > 1;
        if (player.cardsInHand.length < 3)
            return false;
        if (canPlaceCity === false || canPlaceGreenery === false)
            return false;
        if (canPlaceBothLandTiles === false)
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        this.selected = [];
        const remainingActions = this.getRemainingActions(player);
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            return new OrOptions_1.OrOptions(...remainingActions);
        }));
        return undefined;
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromOxygenIncrease(1) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({
            card: card,
            oxygenIncrease: 1,
            oceansToPlace: 1,
            bonusMegaCredits: bonusMegaCredits,
        });
    }
    getRemainingActions(player) {
        const game = player.game;
        const options = [];
        if (!player.game.canAddOcean()) {
            this.selected.push('ocean');
        }
        if (!this.selected.includes('ocean')) {
            options.push(new SelectOption_1.SelectOption('Place an ocean', 'Select', () => {
                this.selected.push('ocean');
                game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
                this.maybeDeferNextAction(player);
                return undefined;
            }));
        }
        if (!this.selected.includes('city')) {
            options.push(new SelectOption_1.SelectOption('Place a city', 'Select', () => {
                this.selected.push('city');
                game.defer(new PlaceCityTile_1.PlaceCityTile(player));
                this.maybeDeferNextAction(player);
                return undefined;
            }));
        }
        if (!this.selected.includes('greenery')) {
            options.push(new SelectOption_1.SelectOption('Place a greenery', 'Select', () => {
                this.selected.push('greenery');
                game.defer(new PlaceGreeneryTile_1.PlaceGreeneryTile(player));
                this.maybeDeferNextAction(player);
                return undefined;
            }));
        }
        if (!this.selected.includes('discard')) {
            options.push(new SelectOption_1.SelectOption('Discard 3 cards', 'Select', () => {
                this.selected.push('discard');
                game.defer(new DiscardCards_1.DiscardCards(player, 3, 'Select 3 cards to discard'), DeferredAction_1.Priority.DEFAULT);
                this.maybeDeferNextAction(player);
                return undefined;
            }));
        }
        return options;
    }
    maybeDeferNextAction(player) {
        if (this.selected.length < 4) {
            const remainingActions = this.getRemainingActions(player);
            player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
                return new OrOptions_1.OrOptions(...remainingActions);
            }));
        }
    }
}
exports.ProjectEden = ProjectEden;
//# sourceMappingURL=ProjectEden.js.map